/* =================================================== Exported Functions =================================================== */
// =================================================== Number
export const roundNumber: TRoundNumber = (number, interval = 10) => {
  const intervalLength = Math.max(String(interval).length - 1, 1);
  const base10 = Math.floor(number / Math.pow(10, intervalLength)) * 10;

  let minNumber = base10;
  let maxNumber = base10;

  while (true) {
    if (minNumber + interval <= number) {
      minNumber = minNumber + interval;
    }

    maxNumber = maxNumber + interval;
    if (maxNumber + interval <= number) {
      maxNumber = maxNumber + interval;
    }

    if (minNumber <= number && number < maxNumber) {
      break;
    }
  }

  const isRoundUp = maxNumber - number < number - minNumber;
  const roundedNumber = isRoundUp ? maxNumber : minNumber;

  return roundedNumber;
};

// =================================================== Currency
export const currencyFormatter: TCurrencyFormatter = (amount) => {
  return Intl.NumberFormat('da-DK', {
    style: 'currency',
    currency: 'DKK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

/* =================================================== Local Types =================================================== */
type TRoundNumber = (number: number, interval?: number) => number;

type TCurrencyFormatter = (amount: number) => string;
